<template>
  <div>
    <v-tabs
        v-model="tabs"
    >
      <v-tab :key="index" v-for="(onglet, index) in onglets">
        {{ onglet.libelle }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item
          :key="index" v-for="(onglet, index) in onglets"
      >
        <v-card
            v-if="onglet.code === 'article_stock'"
            flat
        >
<!--          <v-card-title>Total : {{ totalEnStock | toFixed(2) }} €</v-card-title>-->
          <template v-if="articlesEnStock != null">
            <AffichageArticleStock
                :is-loading="isLoading"
                :fields="fieldsStock.colonneDeposants"
                :lignes="articlesEnStock">

            </AffichageArticleStock>
          </template>
        </v-card>
        <v-card
            v-if="onglet.code === 'article_vendu'"
            flat
        >
          <v-card-title style="font-weight: bolder">Votre cagnotte : {{ totalVendus | toFixed(2) }} €</v-card-title>
          <template v-if="fieldsVendu != null">
            <AffichageLigneAttenteRetrocession
                :is-loading="isLoading"
                :fields="fieldsVendu.colonneDeposants"
                :lignes="articlesVendusNonRetrocedes">

            </AffichageLigneAttenteRetrocession>
          </template>
        </v-card>
        <v-card
            v-if="onglet.code === 'article_paye'"
            flat
        >
<!--          <v-card-title>Total rétrocédé : {{ totalRetrocedes | toFixed(2) }} €</v-card-title>-->
          <template v-if="fieldsRetro != null">
            <AffichageLigneRetrocession
                :is-loading="isLoading"
                :fields="fieldsRetro.colonneDeposants"
                :lignes="articlesVendusRetrocedes">

            </AffichageLigneRetrocession>
          </template>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-row v-if="hasDateFinDepotAsterisque" class="mt-4">
      <span>
        * Suite à la fermeture de la boutique, les dépôts sont prolongés jusqu'au 29 janvier pour les clientes qui le souhaitent.
      </span>
    </v-row>


    <v-snackbar
        absolute
        top
        v-if="configuration && configuration.textDeposant !== ''"
        v-model="snackbar"
        :timeout="-1"
        outlined
        right
        :elevation="24"
    >
      <v-btn
          class="float-right"
          icon
          @click="snackbar = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <p v-html="configuration.textDeposant"></p>

    </v-snackbar>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Ligne, Entete, FieldOnglet, Configuration, Retrocession} from '../models'
import AffichageLigneAttenteRetrocession from './AffichageLigneAttenteRetrocession'
import AffichageLigneRetrocession from './AffichageLigneRetrocession'
import AffichageArticleStock from '@/components/AffichageArticleStock'

export default {
  name: 'Articles',
  components: {
    AffichageArticleStock,
    AffichageLigneAttenteRetrocession,
    AffichageLigneRetrocession
  },
  data () {
    return {
      isLoading: false,
      urlManager: 'http://webtroc-manager',
      snackbar: true,
      tabs: 0
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters({
      // texte: 'Articles/list/getTexte'
    }),
    hasDateFinDepotAsterisque (){
      let retour = false;
      if(this.fieldsStock){
        this.fieldsStock.colonneDeposants.forEach(function(element){
          if(element.value === 'dateFin'){
            if(element.label.includes("*")){
              retour = true;
            }
          }
        })
      }


      return retour;
    },
    articlesEnStock () {
      let deposantId = this.$auth.user.id;

      return Ligne.query()
          .with('article')
          .whereHas('entete', (query) => {
              query.where((value) => value.typeDocument !== 'FAC' || (value.typeDocument === 'FAC' && value.domaine !== 'ACH'))
          })
          .whereHas('article', (query) => {
            query.whereHas('stock', (query) => {
              query.where('quantite', (value) => value > 0)
            }).where('deposant_id', parseInt(deposantId))
          })
          .with('entete')
          .get()
    },
    totalEnStock () {
      let total = 0
      if (this.articlesEnStock.length > 0) {
        this.articlesEnStock.forEach((element) => {
          total += ((element.prixNetTTC - element.montantRemiseTTC) * element.quantite)
        })
      }

      return total
    },
    totalVendus () {
      let total = 0
      if (this.articlesVendusNonRetrocedes.length > 0) {
        this.articlesVendusNonRetrocedes.forEach((element) => {
          // if(element.article){
          //   total += (element.article.prixAchat * element.quantite)
          // } else {
          //   total += ((element.prixNetTTC - element.montantRemiseTTC) * element.quantite)
          // }
          total += parseFloat(element.montantRetrocession);

        })
      }

      return total
    },
    totalRetrocedes () {
      let total = 0
      if (this.articlesVendusRetrocedes.length > 0) {
        this.articlesVendusRetrocedes.forEach((element) => {
          if(!element.aRetroceder){
            total += parseFloat(element.montantRetrocession)
          }
        })
      }

      return total
    },
    articlesVendusNonRetrocedes () {

      let retroAch = Retrocession.query()
          .whereHas('ligne', (query) => {
            query.whereHas('entete', (query) => {
                query.where((value) => value.typeDocument !== 'FAC' || (value.typeDocument === 'FAC' && value.domaine !== 'ACH'))
            })
          })
          .where('articleAbandonne', (value) => value === false)
          .where('articleRendu', (value) => value === false)
          .where('aRetroceder', (value) => value === true)
          .with('article')
          .with('ligne.entete')
          .get();

      let retroNeg = Retrocession.query()
          .hasNot('ligneEntete')
          .hasNot('ligne')
          .where('articleAbandonne', (value) => value === false)
          .where('articleRendu', (value) => value === false)
          .where('aRetroceder', (value) => value === true)
          .get();

      return retroAch.concat(retroNeg).sort((retroA, retroB) => {
          if(retroA.ligne && retroA.ligne.entete){
              if(retroB.ligne && retroB.ligne.entete){
                  return retroA.ligne.entete.dateHeureDebut > retroB.ligne.entete.dateHeureDebut ? -1 : 1
              } else {
                  return -1
              }
          } else {
              if(retroB.ligne && retroB.ligne.entete){
                  return 1
              } else {
                  return 0
              }
          }
      })
    },
    articlesVendusRetrocedes () {
      let retroAch = Retrocession.query()
          .has('article')
          .whereHas('ligne', (query) => {
            query.whereHas('entete', (query) => {
                query.where((value) => value.typeDocument !== 'FAC' || (value.typeDocument === 'FAC' && value.domaine !== 'ACH'))
            })
          })
          .where('articleAbandonne', (value) => value === false)
          .where('articleRendu', (value) => value === false)
          .where('aRetroceder', (value) => value === false)
          .with('article')
          .with('ligne')
          .get();

      let retroVte = Retrocession.query()
          .hasNot('article')
          .whereHas('ligne', (query) => {
            query.whereHas('entete', (query) => {
              query.where('typeDocument', (value) => value !== 'FAC')
                  .where('domaine', (value) => value === 'VTE')
            })
          })
          .where('articleAbandonne', (value) => value === false)
          .where('articleRendu', (value) => value === false)
          .where('aRetroceder', (value) => value === false)
          .with('article')
          .with('ligne')
          .get();

      return retroAch.concat(retroVte).sort((retroA, retroB) => {
          return retroA.paiementDate > retroB.paiementDate ? -1 : 1
      })
    },
    fieldsVendu () {
      return FieldOnglet.query().with('colonneDeposants', (query) => {
        query.where('enabled', true)
      }).where('code', 'article_vendu').first()
    },
    fieldsRetro () {
      return FieldOnglet.query().with('colonneDeposants', (query) => {
        query.where('enabled', true)
      }).where('code', 'article_paye').first()
    },
    fieldsStock () {
      return FieldOnglet.query().with('colonneDeposants', (query) => {
        query.where('enabled', true)
      }).where('code', 'article_stock').first()
    },
    onglets () {
      return FieldOnglet.query().orderBy('order', 'asc').get();
    },
    configuration () {
      return Configuration.query().first()
    }
  },
  methods: {
    init () {
      this.isLoading = true;
      this.urlImages = this.urlManager + '/medias/depots-vente/' + this.$auth.user.depotVente.id + '/article/';
      this.urlNoImages = this.urlManager + '/bundles/webtrocmanager/images/no-picture.png';
      let promise = this.getArticles();
      let promise2 = this.getFields();
      let promise3 = this.getTexte();
      let promise4 = this.getRetrocessions();

      let allPromises = [];
      allPromises.push(promise);
      allPromises.push(promise2);
      allPromises.push(promise3);
      allPromises.push(promise4);

      Promise.all(allPromises).then(() => {

      })
          .catch(() => {

          })
          .finally(() => {
            this.isLoading = false;
          })

    },
    getArticles () {
      return new Promise((resolve) => {
        let promise = Entete.fetchEntetes(this.$auth.user.depotVente.id, this.$auth.user.id)
        promise.then(() => {
          resolve(true)
        })
      })

    },
    getFields () {
      return new Promise((resolve) => {
        let promise = FieldOnglet.fetchFieldOnglets(this.$auth.user.depotVente.id)
        promise.then(() => {
          resolve(true)
        })
      })

    },
    getRetrocessions () {
      return new Promise((resolve) => {
        let promise = Retrocession.fetchRetrocessions(this.$auth.user.depotVente.id, this.$auth.user.id)
        promise.then(() => {
          resolve(true)
        })
      })

    },
    getTexte () {
      return new Promise((resolve) => {
        let promise = Configuration.fetchConfiguration(this.$auth.user.depotVente.id)
        promise.then(() => {
          resolve(true)
        })
      })

    },
    getSrcPhoto (photos) {
      if (photos && photos.length > 0) {
        if (photos[0].nom) {
          return this.urlImages + photos[0].nom
        } else {
          return this.urlNoImages
        }
      } else {
        return this.urlNoImages
      }

    },
    formatDate (value) {
      if (value != null) {
        let date = new Date(value)
        let hours = date.getHours()
        let minutes = date.getMinutes()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()

        if (month < 10) {
          month = '0' + month
        }

        if (day < 10) {
          day = '0' + day
        }

        if (hours < 10) {
          hours = '0' + hours
        }

        if (minutes < 10) {
          minutes = '0' + minutes
        }

        return day + '/' + month + '/' + year
      }
    },
    getDateFin (dateDebut) {
      let date = new Date(dateDebut)
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let year = date.getFullYear()
      let month = date.getMonth() + 3
      let day = date.getDate()

      if (month > 12) {
        month = month - 12
        year = year + 1
      }

      if (month < 10) {
        month = '0' + month
      }

      if (day < 10) {
        day = '0' + day
      }

      if (hours < 10) {
        hours = '0' + hours
      }

      if (minutes < 10) {
        minutes = '0' + minutes
      }

      return day + '/' + month + '/' + year
    }
  },
}
</script>

<style scoped>

</style>
